import { html } from 'htm/preact'
import { useState, useEffect } from 'preact/hooks'
import { token } from '../api.js'
import { useAppState } from '../state.js'
import Topbar from './Topbar.js'
import Toast from './Toast.js'
import Login from '../screens/Login.js'
import Recipes from '../screens/Recipes.js'
import Ingredients from '../screens/Ingredients.js'

function applyTheme(theme) {
  const root = document.documentElement
  if (theme === 'system') {
    root.removeAttribute('data-theme')
  } else {
    root.setAttribute('data-theme', theme)
  }
}

export default function App() {
  const [state, dispatch] = useAppState()
  const [route, setRoute] = useState(() => parseRoute())
  const [toast, setToast] = useState(null)
  const [toastErr, setToastErr] = useState(false)

  useEffect(() => {
    applyTheme(state.theme)
    localStorage.setItem('mc-theme', state.theme)
  }, [state.theme])

  useEffect(() => {
    const handler = () => {
      const r = parseRoute()
      setRoute(r)
      if (!token() && r.name !== 'login') {
        location.hash = '#/login'
      }
    }
    window.addEventListener('hashchange', handler)
    return () => window.removeEventListener('hashchange', handler)
  }, [])

  useEffect(() => {
    const isLocal = location.hostname === 'localhost' || location.hostname === '127.0.0.1'
    if ('serviceWorker' in navigator && location.protocol !== 'file:' && !isLocal) {
      navigator.serviceWorker.register('/sw.js').catch(() => {})
    }
  }, [])

  function parseRoute() {
    const raw = (location.hash || '#/').replace(/^#\/?/, '')
    const parts = raw.split('/').filter(Boolean)
    if (!token()) return { name: 'login' }
    if (parts[0] === 'ingredients') return { name: 'ingredients' }
    return { name: 'home' }
  }

  function showToast(msg, isErr = false) {
    setToast(msg)
    setToastErr(isErr)
    setTimeout(() => setToast(null), 3200)
  }

  const showNav = route.name !== 'login'
  const title = route.name === 'ingredients' ? 'Ingredients' : 'Recipes'

  return html`
    ${route.name !== 'login' && html`<${Topbar} title=${title} showNav=${showNav} />`}
    <main class="main" role="main">
      ${route.name === 'login' && html`<${Login} />`}
      ${route.name === 'home' && html`<${Recipes} showToast=${showToast} />`}
      ${route.name === 'ingredients' && html`<${Ingredients} showToast=${showToast} />`}
    </main>
    ${toast && html`<${Toast} message=${toast} isError=${toastErr} />`}
  `
}